<template>
  <div>
    <!-- INPUT -->
    <div class="position-relative collapse show" :class="toggleClass">
      <input class="form-control"
             type="text"
             :placeholder="placeholder"
             data-bs-toggle="collapse"
             :data-bs-target="'.' + toggleClass"
             data-js-input-hider="true"
             @change="clearInput"
             @click="focusCkEditor"
      >
      <div v-if="pointsGained" class="position-absolute top-50 end-0 me-10px translate-middle-y text-success bg-white" style="z-index: 10;">+{{pointsGained}}b</div>
    </div>

    <!-- EDITOR -->
    <div class="collapse" :class="toggleClass" ref="editor">
      <div :id="toggleClass">
        <slot v-if="loaded && user" />

        <span v-if="loaded && !user" class="text-gray">Na pridávanie obsahu musíš byť <a href="/login">prihlásený</a>.</span>
      </div>

      <div class="mt-10px" v-if="loaded && user">
        <button class="btn btn-primary" @click="save">Uložiť</button>
        <span class="me-5px"></span>
        <button ref="cancelButton" class="btn btn-secondary" type="button" data-bs-toggle="collapse" :data-bs-target="'.' + toggleClass">Zrušiť</button>
      </div>
    </div>
  </div>
</template>

<script>
import InputHider from "../InputHider";
import { getUser } from "../helpers/User";

export default {
  name: "InputHider",
  props: {
    toggleClass: String,
    saveHandler: Function,
    pointsGained: {
      type: Number,
      required: false,
      default: 0
    },
    placeholder: {
      type: String,
      default: 'Pridaj nový'
    }
  },
  data() {
    return {
      loaded: false,
      user: null
    }
  },
  methods: {
    save() {
      this.saveHandler();
      this.$refs.cancelButton.click();
    },
    clearInput(e) {
      e.target.value = '';
    },
    focusCkEditor() {
      const ckEditor = this.$refs.editor.querySelector('.ck-content');

      if (ckEditor) {
        setTimeout(() => {
          ckEditor.focus();
        }, 500);
      }
    },
  },
  mounted() {
    InputHider();

    getUser().then(res => {
      this.user = res.data;
      this.loaded = true;
    });
  }
}
</script>
